<div class="tab-box">
  <div class="title-ind">
  <h1 class="title-tab">Clientes</h1>
  <div class="stackedBarTitle">
    <canvas #stackedCanvasTitleCliente></canvas>
  </div>
</div>
    <div class="acciones-tabla">
     
      <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
      <div>
        <button class="boton-descarga" (click)="exportAsExcel()">
          <img class="boton-descarga__icon" src="../../../../assets/descargar.svg" />
          Descargar
        </button>
      </div>
    </div>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <!-- <ng-container matColumnDef="id">
          <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let cliente" (click)="openDetails(cliente.id)">{{ cliente.id }}</td>
        </ng-container> -->
        <ng-container matColumnDef="nombreComercial">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE
            <!-- <mat-form-field appearance="outline">
              <mat-select name="nombre" placeholder="NOMBRE" class="filtro-tabla" [(ngModel)]="selectedValue" multiple>
                <div class="boton-filtro" (click)="unselect()">Limpiar Filtros</div>
                <mat-option *ngFor="let cliente of clienteFilter" [value]="cliente" #matOption (click)="selectCliente(matOption)">
                  {{cliente.nombreComercial}}
                </mat-option>
      
              </mat-select>
             
            </mat-form-field> -->

          </th>
          <td mat-cell *matCellDef="let cliente" (click)="openDetails(cliente.id)">
            {{ cliente.nombreComercial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cif">
          <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>CIF</th>
          <td mat-cell *matCellDef="let cliente" (click)="openDetails(cliente.id)">{{ cliente.cif }}</td>
        </ng-container>
        <ng-container matColumnDef="contactoResponsable.nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CONTACTO</th>
          <td mat-cell *matCellDef="let cliente" (click)="openDetails(cliente.id)">{{ cliente.contactoResponsable?.nombre }}</td>
        </ng-container>
        <ng-container matColumnDef="indicadores">
          <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
          <td mat-cell *matCellDef="let cliente">
            <div class="stackedBar">
              <canvas #stackedCanvasCliente id="{{cliente.id}}"></canvas>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: tableColumns"
          class="scroll"
        ></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[10,15,20]" (click)="getClientesByContratista()"></mat-paginator>
  </div>
  